import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {AutoComplete} from 'primeng/autocomplete';
import {UnitService} from '../../../core/services/unit/unit.service';
import {finalize, Subject, takeUntil} from 'rxjs';
import {GetUnitByUserIdResponse} from '../../../core/services/unit/models/unit-by-user-id';
import {FormsModule} from '@angular/forms';
import {Skeleton} from 'primeng/skeleton';

@Component({
  selector: 'app-unit-company-selection',
  imports: [
    AutoComplete,
    FormsModule,
    Skeleton
  ],
  templateUrl: './unit-company-selection.component.html',
  styleUrl: './unit-company-selection.component.scss'
})
export class UnitCompanySelectionComponent implements OnInit, OnDestroy {
  public list: GetUnitByUserIdResponse[] = [];
  public filterList: GetUnitByUserIdResponse[] = [];
  public selectedUnit?: GetUnitByUserIdResponse;
  public isLoading: boolean = false;

  private readonly _unitService: UnitService = inject(UnitService);
  private readonly _destroy$: Subject<void> = new Subject<void>();

  public ngOnInit(): void {
    this._getUnits();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public setUnit(unit: GetUnitByUserIdResponse): void {
    this.selectedUnit = unit;
    this._unitService.setSelectedUnit(unit);
  }

  public search(event: any): void {
    this.filterList = event.query ? this.list.filter(x =>
      x.name.toLowerCase().includes(event.query.toLowerCase())) : [...this.list];
  }

  private _getUnits(): void {
    const userId = sessionStorage.getItem('userId');
    if (!userId)
      return;

    this.isLoading = true;
    this._unitService.getUnitByUserId(+userId)
      .pipe(takeUntil(this._destroy$), finalize(() => {
        this.isLoading = false;
      }))
      .subscribe({
        next: (response) => {
          this.list = response;

          const defaultUnit = this._unitService.getSelectedUnit();
          this.selectedUnit = defaultUnit ?? this.list[0];
        }
      });
  }
}
